export default "__VITE_ASSET__CyYcTrDt__"